import { ArrowRight, BookOpen, CalendarDays } from "lucide-react";
import { Link } from "wouter";
import { CtaBand } from "@/components/site/CtaBand";
import { PageHero } from "@/components/site/PageHero";
import { SiteLayout } from "@/components/site/SiteLayout";
import { blogPosts } from "@/content/blogPosts";

function formatDate(value: string) {
  return new Date(`${value}T12:00:00Z`).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  });
}

export default function Blog() {
  const [featured, ...archive] = blogPosts;

  return (
    <SiteLayout>
      <PageHero
        currentPage="Blog"
        eyebrow="Movement, recovery & active-living insights"
        title={<>Ideas for moving through <em>life well.</em></>}
        description="Explore the preserved CORE Strategies PT article archive—perspectives on movement, exercise, injury prevention, sport, rehabilitation, and the many ways people stay active."
        aside={
          <div className="hero-fact-card">
            <span className="hero-fact-icon"><BookOpen size={22} /></span>
            <strong>Legacy archive, preserved</strong>
            <p>Every article from the previous website has been retained with its original date and a unique, readable URL.</p>
          </div>
        }
      />

      <section className="page-section page-section-white" aria-labelledby="featured-article-title">
        <div className="container featured-article">
          <div className="featured-art" aria-hidden="true">
            <span>CORE</span>
            <div className="featured-orbit orbit-a" />
            <div className="featured-orbit orbit-b" />
          </div>
          <div>
            <p className="section-kicker">Featured from the archive</p>
            <div className="article-meta"><CalendarDays size={15} /> {formatDate(featured.published)} · {featured.author}</div>
            <h2 id="featured-article-title">{featured.title}</h2>
            <p>{featured.excerpt}</p>
            <Link className="button-primary" href={`/blog/${featured.slug}`}>Read article <ArrowRight size={18} /></Link>
          </div>
        </div>
      </section>

      <section className="page-section blog-archive-section" aria-labelledby="archive-title">
        <div className="container">
          <div className="archive-heading">
            <div><p className="section-kicker">Explore the archive</p><h2 id="archive-title">Movement ideas through the years.</h2></div>
            <p>Older articles are presented in their historical context. Health guidance, statistics, technologies, and programs may have changed since publication.</p>
          </div>
          <div className="blog-grid">
            {archive.map((post) => (
              <article className="blog-card" key={post.slug}>
                <div className="article-meta"><CalendarDays size={14} /> {formatDate(post.published)}</div>
                <h3><Link href={`/blog/${post.slug}`}>{post.title}</Link></h3>
                <p>{post.excerpt}</p>
                <Link className="text-link" href={`/blog/${post.slug}`}>Read article <ArrowRight size={16} /></Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      <CtaBand title="Have a question about your own movement?" body="Articles can offer useful context, but they are not a substitute for an individualized evaluation. The office can help you begin the right conversation." />
    </SiteLayout>
  );
}
